var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
    click: function click() {
      return _vm.$emit('click');
    }
  } : {}), [_vm._t("icon"), _c('v-list-item-content', [_c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.titleReadable) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.titleReadable) + " ")]), _c('v-chip', {
    attrs: {
      "x-small": "",
      "color": _vm.item.statusColor
    }
  }, [_vm._v(" " + _vm._s(_vm.item.statusReadable) + " ")])], 1), !_vm.small ? _c('v-list-item-subtitle', [_vm.item.seller ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.seller")) + " " + _vm._s(_vm.item.seller.name) + " ")]) : _vm._e(), _vm.item.buyer ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.buyer")) + " " + _vm._s(_vm.item.buyer.name) + " ")]) : _vm._e(), _c('v-chip', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("enums.ClearanceApprovalTypeEnum.".concat(_vm.item.type))) + " ")])], 1) : _vm._e(), !_vm.small && (_vm.item.subTotal || _vm.item.due) ? _c('v-list-item-subtitle', [_vm.item.subTotal ? _c('v-chip', {
    attrs: {
      "color": "success",
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.item.subTotal, _vm.item.currency)) + " ")]) : _vm._e(), _vm.item.due ? _c('span', [new Date(_vm.item.due) > new Date() ? _c('v-chip', {
    attrs: {
      "color": "success",
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(_vm.item.due)) + " ")]) : _c('v-chip', {
    attrs: {
      "color": "error",
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(_vm.item.due)) + " ")])], 1) : _vm._e()], 1) : _vm._e()], 1)], 2) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }